import React, { useState } from 'react'
import { Dialog} from 'components/ui'

export default function ReadyToAssignDialog(props) {

    const {
        type,
        title,
        children,
        onCancel,
        onConfirm,
        packageID,
        draft_packageID,
        confirmButtonColor,
        onRevertSuccess,
        ...rest
    } = props

    const [message, setMessage] = useState("")

    return (
        <Dialog
            style={{
                marginTop: 250,
            }}
            contentClassName="pb-0 px-0"
            {...rest}
        >
            <div className="p-4">
                <h5 className="mb-2">{title}</h5>
                <input
                    className="w-full p-2 border border-gray-300 rounded"
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                    type="text"
                    placeholder="Message"
                    required
                />
                <div className="flex justify-end mt-4">
                    <button
                        className="px-4 py-2 bg-gray-200 rounded mr-2"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={!message}
                        className='px-4 py-2 text-white rounded bg-blue-500'
                        onClick={() => onConfirm(message)}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </Dialog>
    )
}
